//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "deskDiaryDiscount",
  data(){
    return{
        couponId:this.$route.query.couponId,
        bigBgImg:require("@/assets/images/coupon/bigbg@2x.jpg"),
        bgImg:require('@/assets/images/coupon/bg2@2x.png'),
        sharedCard:new Array(),
        coupon:new Array()
    }
  },
  mounted() {
    this.$store.commit('UPDATE_HEAD',false);
    this.$store.commit('UPDATE_FOOTER',false);
    this.$store.commit('UPDATE_PAGE_TITLE','台历3折券');
    document.title = '台历3折券'
    this.getCoupon()
  },
  methods:{
    checkIsAppleDevice(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let iPad = u.indexOf('iPad') > -1;
        let iPhone = u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1;
        if (ios || iPad || iPhone) {
            return true;
        } else {
            return false;
        }
    },
    getCoupon(){
      let self = this;
      this.baseAjax({
          url:'/coupon/get',
          showLoading:true,
          type:'post',
          data:{
              "couponId":self.couponId
          },
          success:function (data) {
              console.log(data.coupon.shareCardKey)
            self.coupon = data.coupon
            self.getSharedInfo()
          }
      })
    },
    getSharedInfo(){
        let self = this;
        this.baseAjax({
            url:'/h5/getCard',
            showLoading:true,
            type:'post',
            data:{
                "type":"share_coupon",
                "returnType":"card",
                "couponId":self.couponId,
                "shareKey":self.coupon.shareCardKey
            },
            success:function (data) {
                console.log(data)
                self.sharedCard = data.card
            }
        })
    },
    shared(){
        console.log('分享')
        let sharedInfo = {
            "title":this.sharedCard.title,
            "content":this.sharedCard.desc,
            "imageUrl":this.sharedCard.imgUrl,
            "link":this.sharedCard.link
        }
        console.log(sharedInfo)
        if(this.checkIsAppleDevice()){
            window.webkit.messageHandlers.shareWX.postMessage(sharedInfo);
        }else{
            if(window.mianhuain != undefined){
                let jsonStr = JSON.stringify(sharedInfo)
                window.mianhuain.shareWX(jsonStr);
            }
        }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/cardCoupons/deskDiaryDiscount.vue